import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";

import { Hero } from "./components/Hero";
import { TrustBar } from "./components/TrustBar";
import { FuzzFeature } from "./components/FuzzFeature";
import { VibeFeature } from "./components/VibeFeature";
import { SOSFeature } from "./components/SOSFeature";
import { HowItWorks } from "./components/HowItWorks";
import { UseCases } from "./components/UseCases";
import { Testimonials } from "./components/Testimonials";
import { FinalCTA } from "./components/FinalCTA";

import About from "./pages/About";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";


import "./App.css";
import ContactUs from "./pages/ContactUs";
import { Scroll } from "lucide-react";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
    <ScrollToTop />
      <div className="App">
        <Toaster position="top-center" richColors />
        <Header />

        <Routes>
          {/* Home Page */}
          <Route
            path="/"
            element={
              <main>
                <Hero />
                <TrustBar />
                <FuzzFeature />
                <VibeFeature />
                <SOSFeature />
                <HowItWorks />
                <UseCases />
                <Testimonials />
                <FinalCTA />
              </main>
            }
          />

          {/* Footer Pages */}
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>

        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;